import styled from "@emotion/styled"
import { spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { SkeletonPicture } from "./SkeletonPicture"
import { SkeletonText } from "./SkeletonText"

interface SkeletonColorTileProps {
	size?: "large"
	withLabel?: boolean
}

export const SkeletonColorTile = ({ size, withLabel }: SkeletonColorTileProps) => {
	return withLabel ? (
		<Wrapper>
			<SkeletonBox $size={size} />
			<SkeletonText $width="100px" />
		</Wrapper>
	) : (
		<SkeletonBox $size={size} />
	)
}

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: ${spacingStaticSm};
`

const SkeletonBox = styled(SkeletonPicture)<{ $size?: "large" }>`
	aspect-ratio: 1;
	width: ${({ $size }) => ($size === "large" ? "28px" : "24px")};
`
